import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { TypeEvent } from 'shell/models/type-event';

export interface transformTypeEventResponse {
  id?: string | number;
  code?: string;
  description?: string;
}

export const transformTypeEvent = (
  response: AxiosResponse<HttpResponse<TypeEvent>>
): transformTypeEventResponse => {
  const data: TypeEvent = response.data.payload || {};
  const res: transformTypeEventResponse = {
    id: data?.codice || '',
    code: data?.codice || '',
    description: data?.descrizione || '',
  };
  return res;
};
